

















import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import { v1 as uuid } from 'uuid';

@Component
export default class Checkbox extends Vue {
  @Prop(String) label!: string;
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) crossed!: boolean;
  @Prop(Boolean) partial!: boolean;
  @Prop(Boolean) value!: boolean;
  @Prop(Boolean) change!: boolean;

  uid = uuid();

  get inputVal() {
    return this.value;
  }

  set inputVal(value: boolean) {
    this.$emit('input', value);
  }
}
